module.exports = __webpack_public_path__ + "img/before.21889fcd.jpg";